// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/finance/wallet.proto" (package "mlmbox.client.finance", syntax proto3)
// tslint:disable
import { Wallet_Processing_Asset_WithdrawalAddressHistory } from "../../types/wallet.ts";
import { Wallet_Processing_Asset_Id } from "../../types/wallet.ts";
import { Wallet_Processing_List } from "../../types/wallet.ts";
import { Wallet_Processing } from "../../types/wallet.ts";
import { Wallet_Processing_Id } from "../../types/wallet.ts";
import { Wallet_Asset_WithdrawalCapacity } from "../../types/wallet.ts";
import { Asset_Id } from "../../types/asset.ts";
import { Wallet_Asset_Transaction_List } from "../../types/wallet.ts";
import { Wallet_Asset_Transaction } from "../../types/wallet.ts";
import { Wallet_Asset_Transaction_Id } from "../../types/wallet.ts";
import { Wallet_Asset_List } from "../../types/wallet.ts";
import { Wallet_Asset } from "../../types/wallet.ts";
import { Wallet as Wallet$ } from "../../types/wallet.ts";
import { Empty } from "../../../google/protobuf/empty.ts";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Asset_Amount } from "../../types/asset.ts";
import { Account_Id } from "../../types/account.ts";
import { Wallet_Asset_Transaction_Kind_Id } from "../../types/wallet.ts";
import { Sort } from "../../types/sort.ts";
/**
 * @generated from protobuf message mlmbox.client.finance.WalletAssetGetRequest
 */
export interface WalletAssetGetRequest {
    /**
     * @generated from protobuf field: uint32 asset_id = 1;
     */
    assetId: number;
    /**
     * @generated from protobuf field: mlmbox.types.Sort sort_transactions = 2;
     */
    sortTransactions?: Sort;
    /**
     * @generated from protobuf field: repeated mlmbox.types.Wallet.Asset.Transaction.Kind.Id filter_kind_ids = 3;
     */
    filterKindIds: Wallet_Asset_Transaction_Kind_Id[];
}
/**
 * @generated from protobuf message mlmbox.client.finance.WalletAssetTransactionListRequest
 */
export interface WalletAssetTransactionListRequest {
    /**
     * @generated from protobuf field: uint32 asset_id = 1;
     */
    assetId: number;
    /**
     * @generated from protobuf field: uint32 step_transaction_id = 2;
     */
    stepTransactionId: number;
    /**
     * @generated from protobuf field: mlmbox.types.Sort sort_transactions = 3;
     */
    sortTransactions?: Sort;
    /**
     * @generated from protobuf field: repeated mlmbox.types.Wallet.Asset.Transaction.Kind.Id filter_kind_ids = 4;
     */
    filterKindIds: Wallet_Asset_Transaction_Kind_Id[];
}
/**
 * @generated from protobuf message mlmbox.client.finance.WalletDepositAddressResponse
 */
export interface WalletDepositAddressResponse {
    /**
     * @generated from protobuf field: string address = 1;
     */
    address: string;
}
/**
 * @generated from protobuf message mlmbox.client.finance.TransferRequest
 */
export interface TransferRequest {
    /**
     * @generated from protobuf field: mlmbox.types.Account.Id account = 1;
     */
    account?: Account_Id;
    /**
     * @generated from protobuf field: mlmbox.types.Asset.Amount operation_amount = 2;
     */
    operationAmount?: Asset_Amount;
}
/**
 * @generated from protobuf message mlmbox.client.finance.WalletValidateAddressRequest
 */
export interface WalletValidateAddressRequest {
    /**
     * @generated from protobuf field: uint32 processing_id = 1;
     */
    processingId: number;
    /**
     * @generated from protobuf field: string address = 2;
     */
    address: string;
}
/**
 * @generated from protobuf message mlmbox.client.finance.WalletValidateAddressResponse
 */
export interface WalletValidateAddressResponse {
    /**
     * @generated from protobuf field: string address = 1;
     */
    address: string;
    /**
     * @generated from protobuf field: bool validated = 2;
     */
    validated: boolean;
}
/**
 * @generated from protobuf message mlmbox.client.finance.WalletWithdrawalRequest
 */
export interface WalletWithdrawalRequest {
    /**
     * @generated from protobuf field: uint32 processing_id = 1;
     */
    processingId: number;
    /**
     * @generated from protobuf field: mlmbox.types.Asset.Amount operation_amount = 2;
     */
    operationAmount?: Asset_Amount;
    /**
     * @generated from protobuf field: string address = 3;
     */
    address: string;
    /**
     * @generated from protobuf field: string verified_code = 4;
     */
    verifiedCode: string;
    /**
     * @generated from protobuf field: bool operation_fee_from_body = 5;
     */
    operationFeeFromBody: boolean;
}
// @generated message type with reflection information, may provide speed optimized methods
class WalletAssetGetRequest$Type extends MessageType<WalletAssetGetRequest> {
    constructor() {
        super("mlmbox.client.finance.WalletAssetGetRequest", [
            { no: 1, name: "asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "sort_transactions", kind: "message", T: () => Sort },
            { no: 3, name: "filter_kind_ids", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["mlmbox.types.Wallet.Asset.Transaction.Kind.Id", Wallet_Asset_Transaction_Kind_Id] }
        ]);
    }
    create(value?: PartialMessage<WalletAssetGetRequest>): WalletAssetGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assetId = 0;
        message.filterKindIds = [];
        if (value !== undefined)
            reflectionMergePartial<WalletAssetGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WalletAssetGetRequest): WalletAssetGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 asset_id */ 1:
                    message.assetId = reader.uint32();
                    break;
                case /* mlmbox.types.Sort sort_transactions */ 2:
                    message.sortTransactions = Sort.internalBinaryRead(reader, reader.uint32(), options, message.sortTransactions);
                    break;
                case /* repeated mlmbox.types.Wallet.Asset.Transaction.Kind.Id filter_kind_ids */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.filterKindIds.push(reader.int32());
                    else
                        message.filterKindIds.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WalletAssetGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 asset_id = 1; */
        if (message.assetId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.assetId);
        /* mlmbox.types.Sort sort_transactions = 2; */
        if (message.sortTransactions)
            Sort.internalBinaryWrite(message.sortTransactions, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Wallet.Asset.Transaction.Kind.Id filter_kind_ids = 3; */
        if (message.filterKindIds.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.filterKindIds.length; i++)
                writer.int32(message.filterKindIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.finance.WalletAssetGetRequest
 */
export const WalletAssetGetRequest = new WalletAssetGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WalletAssetTransactionListRequest$Type extends MessageType<WalletAssetTransactionListRequest> {
    constructor() {
        super("mlmbox.client.finance.WalletAssetTransactionListRequest", [
            { no: 1, name: "asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "step_transaction_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "sort_transactions", kind: "message", T: () => Sort },
            { no: 4, name: "filter_kind_ids", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["mlmbox.types.Wallet.Asset.Transaction.Kind.Id", Wallet_Asset_Transaction_Kind_Id] }
        ]);
    }
    create(value?: PartialMessage<WalletAssetTransactionListRequest>): WalletAssetTransactionListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assetId = 0;
        message.stepTransactionId = 0;
        message.filterKindIds = [];
        if (value !== undefined)
            reflectionMergePartial<WalletAssetTransactionListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WalletAssetTransactionListRequest): WalletAssetTransactionListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 asset_id */ 1:
                    message.assetId = reader.uint32();
                    break;
                case /* uint32 step_transaction_id */ 2:
                    message.stepTransactionId = reader.uint32();
                    break;
                case /* mlmbox.types.Sort sort_transactions */ 3:
                    message.sortTransactions = Sort.internalBinaryRead(reader, reader.uint32(), options, message.sortTransactions);
                    break;
                case /* repeated mlmbox.types.Wallet.Asset.Transaction.Kind.Id filter_kind_ids */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.filterKindIds.push(reader.int32());
                    else
                        message.filterKindIds.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WalletAssetTransactionListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 asset_id = 1; */
        if (message.assetId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.assetId);
        /* uint32 step_transaction_id = 2; */
        if (message.stepTransactionId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.stepTransactionId);
        /* mlmbox.types.Sort sort_transactions = 3; */
        if (message.sortTransactions)
            Sort.internalBinaryWrite(message.sortTransactions, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Wallet.Asset.Transaction.Kind.Id filter_kind_ids = 4; */
        if (message.filterKindIds.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.filterKindIds.length; i++)
                writer.int32(message.filterKindIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.finance.WalletAssetTransactionListRequest
 */
export const WalletAssetTransactionListRequest = new WalletAssetTransactionListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WalletDepositAddressResponse$Type extends MessageType<WalletDepositAddressResponse> {
    constructor() {
        super("mlmbox.client.finance.WalletDepositAddressResponse", [
            { no: 1, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WalletDepositAddressResponse>): WalletDepositAddressResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.address = "";
        if (value !== undefined)
            reflectionMergePartial<WalletDepositAddressResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WalletDepositAddressResponse): WalletDepositAddressResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string address */ 1:
                    message.address = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WalletDepositAddressResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string address = 1; */
        if (message.address !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.address);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.finance.WalletDepositAddressResponse
 */
export const WalletDepositAddressResponse = new WalletDepositAddressResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransferRequest$Type extends MessageType<TransferRequest> {
    constructor() {
        super("mlmbox.client.finance.TransferRequest", [
            { no: 1, name: "account", kind: "message", T: () => Account_Id },
            { no: 2, name: "operation_amount", kind: "message", T: () => Asset_Amount }
        ]);
    }
    create(value?: PartialMessage<TransferRequest>): TransferRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TransferRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TransferRequest): TransferRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Account.Id account */ 1:
                    message.account = Account_Id.internalBinaryRead(reader, reader.uint32(), options, message.account);
                    break;
                case /* mlmbox.types.Asset.Amount operation_amount */ 2:
                    message.operationAmount = Asset_Amount.internalBinaryRead(reader, reader.uint32(), options, message.operationAmount);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TransferRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Account.Id account = 1; */
        if (message.account)
            Account_Id.internalBinaryWrite(message.account, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Asset.Amount operation_amount = 2; */
        if (message.operationAmount)
            Asset_Amount.internalBinaryWrite(message.operationAmount, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.finance.TransferRequest
 */
export const TransferRequest = new TransferRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WalletValidateAddressRequest$Type extends MessageType<WalletValidateAddressRequest> {
    constructor() {
        super("mlmbox.client.finance.WalletValidateAddressRequest", [
            { no: 1, name: "processing_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WalletValidateAddressRequest>): WalletValidateAddressRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.processingId = 0;
        message.address = "";
        if (value !== undefined)
            reflectionMergePartial<WalletValidateAddressRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WalletValidateAddressRequest): WalletValidateAddressRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 processing_id */ 1:
                    message.processingId = reader.uint32();
                    break;
                case /* string address */ 2:
                    message.address = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WalletValidateAddressRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 processing_id = 1; */
        if (message.processingId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.processingId);
        /* string address = 2; */
        if (message.address !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.address);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.finance.WalletValidateAddressRequest
 */
export const WalletValidateAddressRequest = new WalletValidateAddressRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WalletValidateAddressResponse$Type extends MessageType<WalletValidateAddressResponse> {
    constructor() {
        super("mlmbox.client.finance.WalletValidateAddressResponse", [
            { no: 1, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "validated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<WalletValidateAddressResponse>): WalletValidateAddressResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.address = "";
        message.validated = false;
        if (value !== undefined)
            reflectionMergePartial<WalletValidateAddressResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WalletValidateAddressResponse): WalletValidateAddressResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string address */ 1:
                    message.address = reader.string();
                    break;
                case /* bool validated */ 2:
                    message.validated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WalletValidateAddressResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string address = 1; */
        if (message.address !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.address);
        /* bool validated = 2; */
        if (message.validated !== false)
            writer.tag(2, WireType.Varint).bool(message.validated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.finance.WalletValidateAddressResponse
 */
export const WalletValidateAddressResponse = new WalletValidateAddressResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WalletWithdrawalRequest$Type extends MessageType<WalletWithdrawalRequest> {
    constructor() {
        super("mlmbox.client.finance.WalletWithdrawalRequest", [
            { no: 1, name: "processing_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "operation_amount", kind: "message", T: () => Asset_Amount },
            { no: 3, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "verified_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "operation_fee_from_body", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<WalletWithdrawalRequest>): WalletWithdrawalRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.processingId = 0;
        message.address = "";
        message.verifiedCode = "";
        message.operationFeeFromBody = false;
        if (value !== undefined)
            reflectionMergePartial<WalletWithdrawalRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WalletWithdrawalRequest): WalletWithdrawalRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 processing_id */ 1:
                    message.processingId = reader.uint32();
                    break;
                case /* mlmbox.types.Asset.Amount operation_amount */ 2:
                    message.operationAmount = Asset_Amount.internalBinaryRead(reader, reader.uint32(), options, message.operationAmount);
                    break;
                case /* string address */ 3:
                    message.address = reader.string();
                    break;
                case /* string verified_code */ 4:
                    message.verifiedCode = reader.string();
                    break;
                case /* bool operation_fee_from_body */ 5:
                    message.operationFeeFromBody = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WalletWithdrawalRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 processing_id = 1; */
        if (message.processingId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.processingId);
        /* mlmbox.types.Asset.Amount operation_amount = 2; */
        if (message.operationAmount)
            Asset_Amount.internalBinaryWrite(message.operationAmount, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string address = 3; */
        if (message.address !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.address);
        /* string verified_code = 4; */
        if (message.verifiedCode !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.verifiedCode);
        /* bool operation_fee_from_body = 5; */
        if (message.operationFeeFromBody !== false)
            writer.tag(5, WireType.Varint).bool(message.operationFeeFromBody);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.finance.WalletWithdrawalRequest
 */
export const WalletWithdrawalRequest = new WalletWithdrawalRequest$Type();
/**
 * @generated ServiceType for protobuf service mlmbox.client.finance.Wallet
 */
export const Wallet = new ServiceType("mlmbox.client.finance.Wallet", [
    { name: "Info", options: {}, I: Empty, O: Wallet$ },
    { name: "AssetGet", options: {}, I: WalletAssetGetRequest, O: Wallet_Asset },
    { name: "AssetsAll", options: {}, I: Empty, O: Wallet_Asset_List },
    { name: "AssetTransactionGet", options: {}, I: Wallet_Asset_Transaction_Id, O: Wallet_Asset_Transaction },
    { name: "AssetTransactionList", options: {}, I: WalletAssetTransactionListRequest, O: Wallet_Asset_Transaction_List },
    { name: "AssetWithdrawalCapacityGet", options: {}, I: Asset_Id, O: Wallet_Asset_WithdrawalCapacity },
    { name: "ProcessingsGet", options: {}, I: Wallet_Processing_Id, O: Wallet_Processing },
    { name: "ProcessingsAll", options: {}, I: Empty, O: Wallet_Processing_List },
    { name: "Transfer", options: {}, I: TransferRequest, O: Wallet_Asset_Transaction },
    { name: "DepositAddress", options: {}, I: Wallet_Processing_Id, O: WalletDepositAddressResponse },
    { name: "ValidateAddress", options: {}, I: WalletValidateAddressRequest, O: WalletValidateAddressResponse },
    { name: "Withdrawal", options: {}, I: WalletWithdrawalRequest, O: Wallet_Asset_Transaction },
    { name: "WithdrawalAddressHistory", options: {}, I: Wallet_Processing_Asset_Id, O: Wallet_Processing_Asset_WithdrawalAddressHistory }
]);
